import React, { Component } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { TrashAlt } from 'styled-icons/boxicons-solid';
import { Email } from 'styled-icons/material';
import { CloudDownloadFill, ThreeDots } from 'styled-icons/bootstrap';
import { BookPulse, Broom, Mail } from 'styled-icons/fluentui-system-regular';
import { ArrowUpDown } from 'styled-icons/remix-fill';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { fetchDataPostAsync } from '../../../../model/axios/fetchs';
import UserDetailModal from '../../modal/userDetails';
import DownloadStudentsIndividualReport from '../../excel/student';
import DownloadStudentsAllReport from '../../excel/allstudents';
import DownloadStudentsReport from '../../excel/students';
import database from '../../../../model/firebase/firebase';
import male from '../../../../assets/male.png';
import female from '../../../../assets/female.png';
import { StudentListContainer } from '../../../../system/styles/components/userList';

const StudentsList = (props) => {
  const { handleModal, className } = props;

  const { platform } = useSelector((state) => state);
  const { users } = useSelector((state) => state);

  const [state, setState] = React.useState({
    totalUsers: 0,
    users: [],
    renderExport: false,
    showModal: false,
    currentUser: {},
    multiAcceptArray: [],
    reportStore: [],
    carrer: 'todos',
    segment: 'todos',
    onlyApp: false,
    open: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userX, setUserX] = React.useState(null);

  const handleClick = (event, user) => {
    setAnchorEl(event.currentTarget);
    setUserX(user);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [confirmState, setConfirmState] = React.useState({
    email: '',
    id: '',
    user: '',
  });

  const getUsers = () => {
    setState((prev) => ({
      ...prev,
      users: [],
      reportStore: [],
    }));

    const newUsers = users.reduce((acc, element) => {
      if (element.status === 'authorized') {
        acc.push(element);
      }
      return acc;
    }, []);

    setState((prev) => ({
      ...prev,
      users: newUsers,
      reportStore: newUsers,
      renderExport: true,
    }));
  };

  const searchType = (e) => {
    const query = e.target.value;
    const newUsers = users
      .filter((user) => {
        const names = user.names?.toLowerCase().includes(query.toLowerCase());
        const lastNames = user.lastNames?.toLowerCase().includes(query.toLowerCase());
        const id = user.scholarID?.toLowerCase().includes(query.toLowerCase());
        const email = user.email?.toLowerCase().includes(query.toLowerCase());
        return names || lastNames || id || email;
      })
      .sort((a, b) => a.names < b.names);
    setState((prev) => ({
      ...prev,
      users: newUsers,
    }));
  };

  const confirmDelete = (email, id, user) => {
    setConfirmState({
      email,
      id,
      user,
    });
    setState((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const deleteCompany = async (email, id, user) => {
    setState((prev) => ({
      ...prev,
      renderExport: false,
    }));
    await fetchDataPostAsync('rejectUser', { email });
    await database.collection(platform.platformName).doc('data').collection('deletedUsers').doc(id).set(user);
    await database.collection(platform.platformName).doc('data').collection('users').doc(id).delete();
    // TODO: Esto es una mutación directa a redux la eliminaré más sin embargo.
    // users.map((c, i) => {
    //     if (c.id === id) {
    //         users.splice(i, 1);
    //     }
    // });
    // Reescrito
    const newUsers = users.filter((user) => user.id !== id);
    setState((prev) => ({
      users: newUsers,
      renderExport: true,
    }));
  };

  const handleFilter = (e, type) => {
    const campus = type === 'campus' ? e.target.value : state.segment;
    const carrer = type === 'carrer' ? e.target.value : state.carrer;
    const onlyApply = type === 'apply' ? e.target.checked : state.onlyApp;
    let usersFiltered = [];

    setState((prev) => ({
      ...prev,
      users: [],
      reportStore: [],
      segment: campus,
      carrer,
      onlyApp: onlyApply,
    }));

    if (campus !== 'todos' && carrer !== 'todos') {
      usersFiltered = users.filter(
        (user) => user.status === 'authorized' && user.campusSegment === campus && user.career === carrer
      );
    } else if (campus === 'todos' && carrer === 'todos') {
      usersFiltered = users.filter((user) => user.status === 'authorized');
    } else if (campus !== 'todos' && carrer === 'todos') {
      usersFiltered = users.filter((user) => user.status === 'authorized' && user.campusSegment === campus);
    } else if (campus === 'todos' && carrer !== 'todos') {
      usersFiltered = users.filter((user) => user.status === 'authorized' && user.career === carrer);
    }
    if (onlyApply) {
      setState((prev) => ({
        ...prev,
        users: usersFiltered.filter((u) => u.applyCount > 0),
        reportStore: usersFiltered.filter((u) => u.applyCount > 0),
      }));
    } else {
      setState((prev) => ({ ...prev, users: usersFiltered, reportStore: usersFiltered }));
    }
  };

  const close = () => {
    setState((prev) => ({
      ...prev,
      open: !prev.open,
    }));
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    getUsers();
  }, []);

  return (
    <StudentListContainer className={className} adminColor={platform?.adminColor}>
      <div className="a-main-card">
        <Grid container spacing={2}>
          <Grid item lg={2}>
            <h1 className="ac-search-title">Usuarios registrados actualmente</h1>
          </Grid>
          <Grid item lg={2}>
            <input
              type="text"
              id="searchBox"
              placeholder="Buscar por: matrícula, email o nombre"
              className="ac-search-input"
              onChange={searchType}
            />
          </Grid>
          <Grid item lg={2}>
            {platform.carrers.length > 0 ? (
              <>
                <select
                  className="select-filters"
                  id="career"
                  value={state.carrer}
                  onChange={(e) => handleFilter(e, 'carrer')}
                  name="career">
                  <option value="todos" defaultChecked>
                    Filtrar por Carrera
                  </option>
                  {platform.carrers.map((career) => (
                    <option key={career} value={career}>
                      {career}
                    </option>
                  ))}
                </select>
              </>
            ) : null}
          </Grid>
          <Grid item lg={2}>
            {platform.platformCampus.length > 0 ? (
              <>
                <select
                  className="select-filters"
                  id="career"
                  value={state.segment}
                  onChange={(e) => handleFilter(e, 'campus')}
                  name="career">
                  <option value="todos" defaultChecked>
                    Filtrar por campus/ sede/ región
                  </option>
                  {platform.platformCampus.map((career) => (
                    <option key={career} value={career}>
                      {career}
                    </option>
                  ))}
                </select>
              </>
            ) : null}
          </Grid>
          <Grid item lg={4} style={{ display: 'flex' }}>
            {state.renderExport ? <DownloadStudentsIndividualReport studentsDataSet={state.reportStore} /> : null}
            <div className="boxFilter2">
              <label className="label-filters" style={{ width: 120, marginLeft: 10, marginRight: 10 }}>
                Solo usuarios postulados
              </label>
              <input
                name="onlyApp"
                onChange={(e) => handleFilter(e, 'apply')}
                type="checkbox"
                className="select-filters-check"
              />
            </div>
          </Grid>
          <Grid item lg={2} style={{ display: 'flex' }}>
            {state.renderExport ? <DownloadStudentsAllReport studentsDataSet={state.reportStore} /> : null}
          </Grid>
        </Grid>
        <Table className="table students-list">
          <TableHead>
            <TableRow>
              <TableCell scope="col">Estatus de búsquedas</TableCell>
              <TableCell scope="col">Matrícula o ID escolar</TableCell>
              <TableCell scope="col">Nombre</TableCell>
              <TableCell scope="col">Correo</TableCell>
              <TableCell scope="col">Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.users.map((user) => {
              return (
                <TableRow key={user.id}>
                  <TableCell component="th" scope="row">
                    <span
                      style={{
                        padding: '8px 12px',
                        fontWeight: 700,
                        borderRadius: 32,
                        fontFamily: 'Sofia Pro, sans-serif',
                        color:
                          user.userStatus === 'active'
                            ? '#37AB69'
                            : user.userStatus === 'openTo'
                            ? '#0B62FF'
                            : user.userStatus === 'disabled'
                            ? '#F54E0E'
                            : '#37AB69',
                        background:
                          user.userStatus === 'active'
                            ? '#E7F7EF'
                            : user.userStatus === 'openTo'
                            ? '#E1F5FA'
                            : user.userStatus === 'disabled'
                            ? '#FEEEE7'
                            : '#E7F7EF',
                      }}>
                      {user.userStatus === 'active'
                        ? 'En búsqueda activa'
                        : user.userStatus === 'openTo'
                        ? 'Abierto a oportunidades'
                        : user.userStatus === 'disabled'
                        ? 'No disponible'
                        : 'En búsqueda activa'}
                    </span>
                  </TableCell>
                  <TableCell scope="row">{user.scholarID}</TableCell>
                  <TableCell>
                    <img
                      className="gender-img"
                      src={
                        user.gender === 'man' || user.gender === 'male'
                          ? 'https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/static/media/male.9fec2fd1.png'
                          : 'https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/static/media/female.0b9b3660.png'
                      }
                      alt=""
                    />
                    <p className="gender-p">{`${user.names} ${user.lastNames}`}</p>
                  </TableCell>

                  <TableCell>{user.email}</TableCell>
                  <TableCell className="student-action-cell" size="small">
                    <ThreeDots size={24} color="#5F6378" onClick={(e) => handleClick(e, user)} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {state.users.length === 0 ? <p className="text-no">De momento no hay ningún usuario.</p> : null}
      </div>
      {state.renderModal ? <UserDetailModal data={state.currentUser} open={state.showModal} close={close} /> : null}
      {state.open ? (
        <Dialog title="¿Estás segur@ de que deseas eliminar este usuario?" onClose={close}>
          <div className="custom-ui">
            <p className="job-title">
              Al eliminar este usuario perderá acceso a la plataforma <br />y no podra postularse ni dar seguimiento a
              cualquier vacante donde este postulado.
            </p>
            <p className="text">¿Estás segur@ de que deseas eliminar este usuario?</p>
            <DialogActionsBar>
              <button className="k-button" onClick={close}>
                No
              </button>
              <button
                className="k-button"
                onClick={() => {
                  deleteCompany(confirmState.email, confirmState.id, confirmState.user);
                  close();
                }}>
                Yes
              </button>
            </DialogActionsBar>
          </div>
        </Dialog>
      ) : null}
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => confirmDelete(userX?.email, userX?.id, userX)}>
          <p className="admin-student-action-button">
            <Broom className="admin-student-action-icon-delte" size={20} style={{ marginRight: 8 }} />
            Eliminar
          </p>
        </MenuItem>
        <MenuItem>
          <a
            href={`mailto:${userX?.email}`}
            target="_blank"
            rel="noopener noreferrer"
            className="admin-student-action-button">
            <Mail className="admin-student-action-icon-send" size={20} style={{ marginRight: 8 }} />
            Enviar correo
          </a>
        </MenuItem>
        {userX?.cv === '' || userX?.cv === '-----' || userX?.cvData === '' ? null : (
          <MenuItem>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={userX?.cvData ? userX?.cvData : userX?.cv}
              className="admin-student-action-button">
              <CloudDownloadFill className="admin-student-action-icon-download" size={20} />
              <span className="admin-student-action-tooltip">Descargar CV</span>
            </a>
          </MenuItem>
        )}

        <MenuItem>
          <DownloadStudentsIndividualReport
            studentsDataSet={[userX]}
            studentName={`${userX?.names}-${userX?.lastNames}`}
          />
        </MenuItem>
        <MenuItem onClick={() => handleModal(true, userX)}>
          <p className="admin-student-action-button">
            <BookPulse className="see-applicantions" size={20} style={{ marginRight: 8 }} />
            Ver Postulaciones
          </p>
        </MenuItem>
      </Menu>
    </StudentListContainer>
  );
};
export default StudentsList;
